import * as tslib_1 from "tslib";
import store from '../store/store';
import { getFallbackValueIfNull } from 'owa-options-core';
import { updateUserConfiguration } from 'owa-options-core';
import { getUserConfiguration } from 'owa-session-store';
import { action, select } from 'satcheljs/lib/legacy';
export default select({
    optionState: function () { return store; },
    userOptions: function () { return getUserConfiguration().UserOptions; },
})(function saveMessagePreviewOptionFull(state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var optionState, userOptions;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    optionState = state.optionState, userOptions = state.userOptions;
                    return [4 /*yield*/, saveMessagePreviewOption(optionState.showPreviewTextInListView, userOptions)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
});
export var onMessagePreviewToggle = select({
    userOptions: function () { return getUserConfiguration().UserOptions; },
})(function saveMessagePreviewOptionFull(isToggleEnabled, state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var userOptions;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    userOptions = state.userOptions;
                    return [4 /*yield*/, saveMessagePreviewOption(isToggleEnabled, userOptions)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
});
var saveMessagePreviewOption = action('saveMessagePreviewOption')(function saveMessagePreviewOption(isEnabled, userOptions) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    userOptions.ShowPreviewTextInListView = getFallbackValueIfNull(isEnabled, userOptions.ShowPreviewTextInListView);
                    return [4 /*yield*/, updateUserConfiguration([
                            {
                                propertyName: 'ShowPreviewTextInListView',
                                propertyType: 'Boolean',
                                propertyValue: "" + userOptions.ShowPreviewTextInListView,
                            },
                        ])];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
});
//# sourceMappingURL=saveMessagePreviewOption.js.map